// Custom-domain runtime resolution helpers.
// When an org connects a verified custom domain (e.g. give.yourcharity.org), the
// React app is served on that host and must render the org's storefront at "/".
// These helpers decide whether the current host is a platform host (marketing app,
// preview, localhost) or a candidate custom domain to resolve.

const PLATFORM_HOSTS = ["localhost", "127.0.0.1", "0.0.0.0"];
const PLATFORM_SUFFIXES = [
    ".preview.emergentagent.com",
    ".emergentagent.com",
    ".emergent.host",
];

export function isPlatformHost(host) {
    host = (host || "").toLowerCase();
    if (!host) return true;
    if (PLATFORM_HOSTS.includes(host)) return true;
    return PLATFORM_SUFFIXES.some((s) => host.endsWith(s));
}

// Preview/QA override: ?cfhost=give.example.org forces the custom-domain path so
// the flow can be tested end-to-end without real DNS pointing at the preview env.
export function getForcedHost() {
    try {
        return new URLSearchParams(window.location.search).get("cfhost");
    } catch {
        return null;
    }
}
